import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';

import { useStyles } from './styles';
import CommonImages from '../../../commons/images';

function ErrorMsgBox (props) {
    const {
        title = 'Oops!',
        message = 'Something went wrong. Our technical team are looking into the problem. Please try again later.',
        refId = '',
    } = props;

    const classes = useStyles({});
 
    return (
        <React.Fragment>
            <Grid
                id="error-message-container"
                className={classes.errorMsgBox}
            >
                <Grid className={classes.errorMessageTitleContainer}>
                    <Grid className={classes.errorMessageTitleIcon}>
                        <img
                            src={CommonImages.WARNING_ICON}
                            alt="Error"
                            className={classes.bannerImage}
                        />
                    </Grid>
                    <Grid>
                        <span className={classes.errorMessageTitleText}>
                            {title}
                        </span>
                    </Grid>
                </Grid>
               <Grid className={classes.errorMessageMessageContainer}>
                    <p className={classes.errorMessageMessageText}>
                        {message}
                    </p>
                </Grid>
                {refId && <Grid className={classes.errorMessageRefId}>
                    <span>
                        Ref.ID: {refId}
                    </span>
                </Grid>}
            </Grid>           
        </React.Fragment>
    );
}

ErrorMsgBox.propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    refId: PropTypes.string,
};

export default ErrorMsgBox;